/* eslint-disable import/default */
import React from 'react';
import { render } from 'react-dom';
import Main from './src/Main';

render(
  <Main/>, document.getElementById('app')
);



// WEBPACK FOOTER //
// ./entry.js